<div class="breadcrumb-wrapper">
  <div class="container fw-b breadcrumb-container">
    <app-linker-route [headingName]="headingName" [linkerRouteItems]="linkerRouteItems"></app-linker-route>
  </div>
</div>

<div class="container service-detail-wrapper">
  <div class="page-card">
    <app-table-loader *ngIf="!isLoading"></app-table-loader>
    <div *ngIf="isLoading" class="service-detail-content">
    <div class="row service-detail-row">
      <!-- Service Image Section -->
      <div class="col-lg-5 col-md-5 col-sm-12 service-image-section">
        <div class="service-image-container">
          <img 
            class="service-main-image" 
            [hidden]="!isLoaded" 
            (load)="onImageLoad()"
            [src]="selectedService?.serviceId?.categoryId?.categoryImage" 
            alt="Service Image" 
          />
          <ngx-skeleton-loader 
            *ngIf="!isLoaded" 
            [theme]="{
              width: '100%',
              height: '405px',
              position: 'relative',
              'border-radius': '12px'
            }" 
            count="1"
          ></ngx-skeleton-loader>
        </div>
      </div>
      
      <!-- Service Details Section -->
      <div class="col-lg-7 col-md-7 col-sm-12 service-info-section">
        <!-- Service Provider Info -->
        <div class="service-provider-header">
          <div class="provider-info">
            <h2 class="service-provider-name">
              {{ selectedService?.userId?.firstName }}
              {{ selectedService?.userId?.lastName }}
            </h2>
            <p class="service-provider-subtitle">Service Provider</p>
          </div>
          <div class="provider-actions">
            <div class="preferred-price-container" *ngIf="!intrestedPrice">
              <button
                class="btn btn-theme int"
                [disabled]="intrestedPrice"
                (click)="openModal()">
                Preferred Price
              </button>
              <span class="info">
                <img src="./../../../../assets/svg/info.svg" alt="info icon" />
              </span>
            </div>
          </div>
        </div>
        
        <!-- Category Name -->
        <div class="service-category-section">
          <h3 class="service-category-name">{{ categoryName }}</h3>
          <div id="accordion">
            <mat-accordion>
              <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)" hideToggle>
                <mat-expansion-panel-header class="faq-qsn">
                  <mat-panel-title class="gg delivery-card-title" style="color: #BE0119">
                    Delivery
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="service-details-container">
                  <!-- Single Row Layout: Delivery Details | Quantity | Prices -->
                  <div class="delivery-card-row">
                    <!-- Left: Delivery Details -->
                    <div class="delivery-details-col">
                      <p class="delivery-details-text">
                        Delivery: {{ selectedService?.serviceId?.serviceName }}
                      </p>
                    </div>
                    
                    <!-- Middle: Quantity Selector -->
                    <div class="delivery-quantity-col">
                      <div class="quantity-controls">
                        <button 
                          class="btn qty-less-high" 
                          [disabled]="selectedService.quantity <= 1" 
                          (click)="updateCartValue('SUB'); selectedService.quantity = selectedService.quantity - 1"
                        >
                          <em class="fa fa-minus"></em>
                        </button>
                        <div class="form-outline qty">
                          <p class="qty m-0">{{ selectedService.quantity }}</p>
                        </div>
                        <button 
                          class="btn qty-less-high" 
                          (click)="updateCartValue('ADD'); selectedService.quantity = selectedService.quantity + 1"
                        >
                          <em class="fa fa-plus"></em>
                        </button>
                      </div>
                    </div>
                    
                    <!-- Right: Prices (Stacked) -->
                    <div class="delivery-price-col">
                      <div class="price-stack" *ngIf="isDiscount">
                        <p class="original-price-stacked" style="text-decoration: line-through; margin: 0 0 4px 0;">
                          {{
                          selectedService?.serviceId.price &&
                          getPrice(selectedService?.serviceId.price | currency : "ZAR" : "R")
                          }}
                        </p>
                        <p class="discount-price-stacked" style="margin: 0;">
                          {{
                          selectedService?.dealPrice &&
                          getPrice(selectedService?.dealPrice | currency : "ZAR" : "R")
                          }}
                          ({{selectedService.dealDiscount}}% Off)
                        </p>
                      </div>
                      <p class="mb-0 ner single-price" *ngIf="!isDiscount" style="margin: 0;">
                        {{
                        selectedService?.dealPrice &&
                        getPrice(selectedService?.dealPrice | currency : "ZAR" : "R")
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>

        <!-- Amount Details Section -->
        <div class="amount-details-section">
          <h2 class="amount-details-heading">Amount Details</h2>
          <div class="amount-row">
            <span class="amount-label">Sub-total</span>
            <span class="amount-value">{{
                priceValueOfService &&
                getPrice(priceValueOfService | currency : "ZAR" : "R")
                }}</span>
            </div>
          <div class="amount-row">
            <span class="amount-label">VAT @15%</span>
            <span class="amount-value">
                {{
                sumToatal && getPrice(sumToatal | currency : "ZAR" : "R")
              }}
            </span>
          </div>
          <div class="amount-row total-row">
            <span class="amount-label">Total to pay</span>
            <span class="amount-value total-amount">{{
                totalPayAmount &&
                getPrice(totalPayAmount | currency : "ZAR" : "R")
                }}</span>
          </div>
        </div>

        <!-- Delivery Details Section -->
        <div class="delivery-details-section">
          <h3 class="delivery-section-heading">Share your details for the delivery of the service</h3>
          <div class="address-card" *ngIf="addressId">
            <div class="address-content">
              <div class="address-info">
                <p class="address-line">
                  <strong class="text-sty">{{ profileData?.addressLine1 }},</strong>
                </p>
                <p class="address-line">
                  <strong class="text-sty">{{ profileData?.zipCode }}</strong>
                </p>
                <div class="phone-info">
                  <i class="fa fa-phone phone-icon" aria-hidden="true"></i>
                  <span class="phone-number">{{ profileData?.countryCode | phoneFormat }}-{{ profileData?.mobileNumber | phoneFormat }}</span>
                </div>
              </div>
              <div class="address-actions">
                <button class="action-btn edit-btn" (click)="navigateToEdit('quantity')" title="Edit Address">
                  <i class="fa fa-edit"></i>
                </button>
                <button class="action-btn list-btn" (click)="openListAddress()" title="List Addresses">
                  <i class="fa fa-list"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="add-address-section">
            <button class="add-cart-btn" (click)="navigateToserviceQuantity('quantity')">
              +Add new address
            </button>
              </div>
          
          <!-- Date and Time Selection -->
          <div class="datetime-selection">
            <div class="date-input-wrapper">
              <input 
                placeholder="Select date" 
                type="date" 
                id="example" 
                [min]="todayDate"
                (change)="onDateChange($event)"
                (input)="onDateChange($event)"
                [(ngModel)]="duration"
                class="form-control change-clr heit" 
              />
            </div>
            <div class="time-select-wrapper">
              <select 
                class="form-control change-clr heit" 
                [(ngModel)]="timeSlots"
              >
                <option value="" selected disabled>Select Slot</option>
                <option *ngFor="let item of slotData" [value]="item">
                  {{ item }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <!-- Proceed to Book Button -->
        <div class="checkout-section">
          <div class="checkout-action-stack">
            <button
              type="button"
              class="checkout-proceed-button premium-trigger"
              data-toggle="modal"
              data-target="#premiumPaymentModal"
              [disabled]="!flag"
            >
              <div class="checkout-button-content">
                <span class="checkout-button-text">Proceed to Book</span>
                <i class="fa fa-arrow-right checkout-arrow" aria-hidden="true"></i>
              </div>
            </button>
            <div class="screen-reader-only" aria-hidden="true" *ngIf="htmlData">
                  <div [innerHTML]="htmlData"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</div>
<!-- <div class="container mt-5">
  <div class="d-flex justify-content-start">
      <h1 class="heading-text-cat">
        Similiar Products
      </h1>
  </div>
  <div class="items mt-4">
      <div class="slick_slider">
          <div class="service_slider slider slider-customize">
              <div *ngFor="let data of serviceData; let i = index">
                  <div style="height: 340px;">
                      <div class="bannerContent">
                          <div class="innerDiv">
                              <div>
                                  <a target="_blank" rel="noopener noreferrer">
                                      <img class="bannerSlideIamge" [src]="data?.thumbnail" /></a>
                              </div>
                              <div class="mt-3">
                                  <p style="color: black;">{{data?.productName}}</p>
                              </div>
                              <div class="mt-3">
                                  <p class="description-text">{{data?.priceSizeDetails[0]?.price && getPrice(data?.priceSizeDetails[0]?.price | currency:"ZAR":"R")}}</p>
                              </div>
                              <div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div> -->
<div class="modal fade" id="listAddressModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content ggg" style="min-width: 600px">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <!-- <div class="d-flex justify-content-center mt-5 mb-4" id="book">
                <img class="for-img1" style="height: 100%;" src="assets/images/book.png" alt="login form"
                    class="img-fluid" />
            </div> -->
      <!-- <h2 class="modal-title d-flex justify-content-center">Are you sure you want to logout?</h2> -->
      <div class="right-side">
        <h1 class="container right-side-text">Address</h1>
        <div class="container mt-4 card card-data" *ngFor="let item of listAddressData">
          <div class="row" (click)="toAddressId(item?._id)">
            <div class="col-lg-8 col-md-8 mb-4 mb-lg-0">
              <p style="margin: 1px; margin-top: 5px">
                <strong class="text-sty">
                  {{ item?.addressLine1 }}
                  <span *ngIf="item?.addressLine2">,</span>
                  {{ item?.addressLine2 }}
                </strong>
              </p>
              <p style="margin: 1px; margin-top: 5px">
                <strong class="text-sty">{{ item?.city }}, {{ item?.state }},{{ item?.country }},
                  {{ item?.zipCode }}</strong>
              </p>
              <div class="mt-3">
                <span><em class="fa fa-phone" aria-hidden="true" style="color: #c01e2f"></em>
                </span>
                &nbsp;&nbsp;
                <span class="phoen">{{ item?.countryCode | phoneFormat }}-{{ item?.mobileNumber | phoneFormat }}</span>
              </div>
            </div>

            <div class="col-lg-4 col-md-4 mb-4 mb-lg-0">
              <div class="d-flex trash" style="max-width: 300px">
                <em class="fa fa-edit ml-2" style="font-size: 22px" (click)="navigateToEdit('quantity')"></em>
                <em class="fa fa-trash ml-2" (click)="addressModals(item?._id, item?.isPrimary)"
                  style="font-size: 21px; color: #BE0119"></em>
              </div>
              <!-- <div class="form-check d-flex trash" style="max-width: 300px;margin-top: 20px;cursor: pointer;">
                                <input class="form-check-input" style="cursor: pointer;" type="radio" name="flexRadioDisabled" (click)="toAddressId(item?._id)" 
                                    id="flexRadioDisabled">
                            </div> -->
            </div>
          </div>
        </div>
        <!-- <div class="row justify-content-between" style="padding: 10px;">
                    <div>
                        <button class="add-cart-btn" routerLink="/edit-address-customer">Add new address</button>
                    </div>
                    <div>
                        <button class="continue-btn" (click)="navigateToOrderOverview()">Continue with this address</button>
                    </div>
                </div> -->
      </div>

      <!-- <div class="modal-body d-flex justify-content-center mb-4">
                <button type="button" class="btn btntt1" data-dismiss="modal" routerLink="/homepage">No</button>
                <button type="button" class="btn btntt ml-3" data-dismiss="modal" routerLink="/login"
                    (click)="logout()">Yes</button>
            </div> -->
    </div>
  </div>
</div>
<!-- delete address Modal -->
<div class="modal fade" id="addressModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content ggg">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="d-flex justify-content-center mt-5 mb-4" id="book">
        <img class="for-img1" style="height: 100%" src="assets/images/book.png" alt="login form" class="img-fluid" />
      </div>
      <h2 class="modal-title d-flex justify-content-center">
        Are you sure you want to delete this address?
      </h2>

      <div class="modal-body d-flex justify-content-center mb-4">
        <button type="button" class="btn btntt1" data-dismiss="modal" routerLink="/homepage">
          No
        </button>
        <button type="button" class="btn btntt ml-3" data-dismiss="modal" (click)="deleteAddress()">
          Yes
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="intrestedPriceModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modern-modal-dialog" role="document" *ngIf="isLoading">
    <div class="modal-content modern-modal-content">
      <div class="modern-modal-header">
        <div class="modal-header-content">
          <h2 class="modern-modal-title">Submit Your Preferred Price</h2>
          <p class="modern-modal-subtitle">Make an offer and the service provider will review your proposal</p>
        </div>
        <button type="button" class="modern-close-btn" data-dismiss="modal" aria-label="Close">
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modern-modal-body">
        <form class="form" (submit)="startCampaign()">
          <!-- Service Preview Section -->
          <div class="modal-product-section">
            <div class="modal-product-left">
              <img class="modal-product-image" [src]="selectedService?.serviceId?.categoryId?.categoryImage" alt="Service Image" />
            </div>
            <div class="modal-product-right">
              <!-- Service Category -->
              <div class="modal-form-group-compact">
                <label class="modal-label">Service Category</label>
                <div class="modal-current-price">
                  {{ selectedService?.serviceCategoryId?.categoryName }}
                </div>
              </div>
              
              <!-- Service Name -->
              <div class="modal-form-group-compact">
                <label class="modal-label">Service</label>
                <div class="modal-current-price">
                  {{ selectedService?.serviceSubCategoryId?.subCategoryName }}
                </div>
              </div>
              
              <!-- Current Price -->
              <div class="modal-form-group-compact">
                <label class="modal-label">Current Price</label>
                <div class="modal-current-price">
                  {{ selectedService?.serviceId?.price ? getPrice(selectedService?.serviceId?.price | currency : "ZAR" : "R") : 'N/A' }}
                </div>
              </div>
            </div>
          </div>

          <!-- Preferred Price Input -->
          <div class="modal-form-group">
            <label class="modal-label" for="preferredPriceInput">Your Preferred Price</label>
            <div class="modal-input-wrapper">
              <span class="currency-symbol">R</span>
              <input
                type="text"
                id="preferredPriceInput"
                class="modal-input"
                [(ngModel)]="_discountedPrice"
                [ngModelOptions]="{standalone: true}"
                placeholder="Enter your price"
                (keypress)="commonService.numberOnly($event)"
                (keypress)="commonService.preventSpace($event);commonService.numberOnly($event)"
                aria-describedby="priceHelp">
            </div>
            <small class="modal-error-text" *ngIf="selectedService?.serviceId?.price < _discountedPrice">
              <i class="fa fa-exclamation-circle"></i> Price cannot exceed current price
            </small>
          </div>

          <!-- Purchase Preference -->
          <div class="modal-form-group">
            <label class="modal-label">Purchase Preference</label>
            <div class="modal-radio-group">
              <label class="modal-radio-option" for="auto-spordaic">
                <input
                  type="radio"
                  (change)="spordicType = 'AUTOMATIC'"
                  name="spordaicSelection"
                  id="auto-spordaic"
                  [checked]="spordicType === 'AUTOMATIC'">
                <span class="modal-radio-content">
                  <span class="modal-radio-title">Automatic</span>
                  <span class="modal-radio-desc">Schedule automatically when campaign is started</span>
                </span>
              </label>
              <label class="modal-radio-option" for="semi-spordaic">
                <input
                  type="radio"
                  (change)="spordicType = 'SEMIAUTOMATIC'"
                  name="spordaicSelection"
                  id="semi-spordaic"
                  [checked]="spordicType === 'SEMIAUTOMATIC'">
                <span class="modal-radio-content">
                  <span class="modal-radio-title">Semi-Automatic</span>
                  <span class="modal-radio-desc">Let me review the scheduled date</span>
                </span>
              </label>
            </div>
          </div>

          <!-- Submit Button -->
          <div class="modal-footer-actions">
            <button
              class="modern-confirm-btn"
              type="submit"
              [disabled]="selectedService?.serviceId?.price < _discountedPrice || !_discountedPrice">
              <i class="fa fa-check-circle"></i>
              Confirm Preferred Price
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- Premium Payment Modal -->
<div
  class="modal fade premium-payment-modal"
  id="premiumPaymentModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered premium-dialog">
    <div class="modal-content premium-modal">
      <button type="button" class="premium-close-btn" data-dismiss="modal" aria-label="Close">
        <i class="fa fa-times"></i>
      </button>
      <div class="premium-modal-header">
        <div class="payment-header-content">
          <i class="fa fa-credit-card payment-header-icon"></i>
          <h3 class="premium-modal-title">Payment Information</h3>
        </div>
        <p class="premium-modal-subtitle">Select Payment Gateway</p>
      </div>
      <div class="premium-modal-body">
        <ng-container *ngIf="!htmlData; else premiumHtmlBlock">
          <div class="premium-payment-section">
            <ng-container *ngIf="flag; else premiumProcessing">
              <div class="payment-option-list">
                <ng-container *ngFor="let item of dropDownData; let i = index">
                  <div
                    class="payment-option"
                    *ngIf="i > 0"
                    [class.selected]="selectedPaymentMethod === item.value"
                    (click)="setSelectedPayment(item.value); $event.stopPropagation()"
                  >
                    <div class="payment-option-content">
                      <div class="payment-icon-wrapper">
                        <img 
                          [src]="getPaymentLogo(item.value)" 
                          [alt]="getPaymentName(item.name, item.value)"
                          class="payment-logo-image"
                        />
                      </div>
                      <div class="payment-details">
                        <div class="payment-header-row">
                          <span class="payment-name">{{ getPaymentName(item.name, item.value) }}</span>
                        </div>
                        <p class="payment-description">{{ getPaymentDescription(item.value) }}</p>
                        <div class="payment-security-features" *ngIf="getPaymentSecurityFeatures(item.value).length > 0">
                          <span 
                            class="security-feature" 
                            *ngFor="let feature of getPaymentSecurityFeatures(item.value); let last = last"
                          >
                            {{ feature }}
                            <span class="security-separator" *ngIf="!last"> • </span>
                          </span>
                        </div>
                      </div>
                      <div class="payment-card-types" *ngIf="getPaymentCardTypes(item.value).length > 0">
                        <span 
                          class="card-type" 
                          *ngFor="let cardType of getPaymentCardTypes(item.value)"
                        >
                          {{ cardType }}
                        </span>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
              
              <div class="payment-modal-actions">
                <button 
                  type="button" 
                  class="btn-cancel" 
                  data-dismiss="modal"
                >
                  Cancel
                </button>
                <button 
                  type="button" 
                  class="btn-proceed-payment"
                  [disabled]="!selectedPaymentMethod"
                  (click)="selectPayment(selectedPaymentMethod)"
                  data-dismiss="modal"
                >
                  Make Payment
                </button>
              </div>
            </ng-container>
            <ng-template #premiumProcessing>
              <div class="payment-processing-loader">
                <div class="spinner"></div>
              </div>
            </ng-template>
          </div>
        </ng-container>
        <ng-template #premiumHtmlBlock>
          <div class="premium-html-display" [innerHTML]="htmlData"></div>
        </ng-template>
      </div>
    </div>
  </div>
</div>